import { render, staticRenderFns } from "./brand_info.vue?vue&type=template&id=f44c8a6c&scoped=true&"
import script from "./brand_info.vue?vue&type=script&lang=js&"
export * from "./brand_info.vue?vue&type=script&lang=js&"
import style0 from "./brand_info.vue?vue&type=style&index=0&id=f44c8a6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44c8a6c",
  null
  
)

export default component.exports